import PageHero from '../components/PageHero';
import styles from '../styles/PrivacyPage.module.css';

const PrivacyPage = () => {
    return (
        <>
            <PageHero
                backgroundImage="/images/Privacy/hero-bg.svg"
                title="Privacy & Data Policy"
                subtitle=""
                description="We're here to help! Whether you have questions or specific requirements, please get in touch with us. You can either use the contact form below or reach us directly via the contact details provided. We look forward to hearing from you!"
                breadcrumb={{
                    home: "Home",
                    current: "Privacy Policy"
                }}
            />
            <div className={styles.privacyContent}>
                <h2 className={styles.privacyTitle}>1. Introduction</h2>
                <p>Symbioun is committed to protecting the privacy and security of our clients' and stakeholders' personal data. This Privacy and Data Policy outlines how we collect, use, disclose, and safeguard your information in relation to our services in consultation, investments, and community development.</p>
                <h2 className={styles.privacyTitle}>2. Information We Collect</h2>
                <ul>
                    <li><b>Personal Information:</b> Name, contact details, business information, financial information, and any other information you provide directly.</li>
                    <li><b>Usage Data:</b> Information about how you use our services, including IP addresses, browser types, and access times.</li>
                    <li><b>Cookies:</b> Data collected through cookies and similar tracking technologies to enhance user experience.</li>
                </ul>
                <h2 className={styles.privacyTitle}>3. How We Use Your Information</h2>
                <ul>
                    <li><b>Consultation Services:</b> To provide business process automation and consultation services tailored to your needs.</li>
                    <li><b>Investment Activities:</b> To evaluate and process venture capital and angel investment opportunities.</li>
                    <li><b>Community Development:</b> To facilitate projects aimed at rural communities and child development.</li>
                    <li><b>Communication:</b> To send updates, newsletters, and promotional materials related to our services.</li>
                    <li><b>Compliance:</b> To comply with legal obligations and protect our rights.</li>
                </ul>
                <h2 className={styles.privacyTitle}>4. Disclosure of Your Information</h2>
                <ul>
                    <li><b>Investors and Partners:</b> In connection with investment opportunities, your information may be shared with potential investors or partners. Additionally, we may share information about our investors with the entities they invest in through us.</li>
                    <li><b>Legal Authorities:</b> To comply with applicable laws, regulations, or legal requests.</li>
                </ul>
                <h2 className={styles.privacyTitle}>5. Data Security</h2>
                <p>We implement reasonable security measures to protect your information from unauthorised access, loss, or misuse. However, no method of transmission over the internet or electronic storage is 100% secure.</p>
                <h2 className={styles.privacyTitle}>6. Data Retention</h2>
                <p>We will retain your personal information only for as long as necessary to fulfil the purposes outlined in this policy, comply with our legal obligations, and resolve disputes.</p>
                <h2 className={styles.privacyTitle}>7. Your Rights</h2>
                <ul>
                    <li>Access your personal data.</li>
                    <li>Request correction or deletion of your personal data.</li>
                    <li>Withdraw consent for data processing, where applicable.</li>
                    <li>Object to the processing of your data for direct marketing purposes.</li>
                </ul>
                <p>To exercise these rights, please contact us using the information below.</p>
                <h2 className={styles.privacyTitle}>8. Changes to This Policy</h2>
                <p>We may update this Privacy and Data Policy from time to time. We will notify you of any changes by posting the new policy on our website with the updated effective date.</p>
                <h2 className={styles.privacyTitle}>9. Contact Us</h2>
                <p>If you have any questions or concerns about this Privacy and Data Policy, please contact us at: <a href="mailto:info@symbioun.lk">info@symbioun.lk</a></p>
            </div>
        </>
    )
}

export default PrivacyPage;

